import Header from './Header';
import Sidebar from './Sidebar';
import OrgRequiredGate from './OrgRequiredGate';

/** Fixed 56px header (surface switcher), then the surface sidebar and the page. */
export default function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col h-screen bg-jeket-black-deep">
      <Header />
      <div className="flex flex-1 min-h-0 pt-14">
        <Sidebar />
        <main className="flex-1 overflow-auto bg-jeket-black-deep">
          <div className="p-6">
            <OrgRequiredGate>{children}</OrgRequiredGate>
          </div>
        </main>
      </div>
    </div>
  );
}
